import { makeGraphQLRequest } from 'graphql/makeGraphQLRequest';
import { getExpertId } from 'util/parseSelectors';
import { GET_BUSINESS_ALERTS_FOR_ACCOUNT, GET_BUSINESS_ALERTS_READ_DATA } from './businessAlert.gql';
import moment from 'moment';
import { alertStatus } from 'constants/alerts';

export const getBusinessAlertsForAccount = async (simplrAccountId) => {
  const businessAlerts = await makeGraphQLRequest(
    GET_BUSINESS_ALERTS_FOR_ACCOUNT,
    {
      filter: {
        simplrAccountId: {
          eq: simplrAccountId,
        },
        status: {
          in: [alertStatus.INACTIVE, alertStatus.ACTIVE],
        },
        or: [
          {
            expirationDate: {
              eq: null,
            },
          },
          {
            expirationDate: {
              gt: moment().utc().toDate(),
            },
          },
        ],
      },
    },
    'businessAlertsFind'
  );

  return businessAlerts?.nodes;
};

export const getBusinessAlertReadData = async (simplrAccountId) => {
  const expertId = getExpertId();

  const businessAlertReadData = await makeGraphQLRequest(
    GET_BUSINESS_ALERTS_READ_DATA,
    {
      filter: {
        simplrAccountId: {
          eq: simplrAccountId,
        },
        simplrExpertId: {
          eq: expertId,
        },
      },
      sorting: [
        {
          direction: 'ASC',
          field: 'createdAt',
        },
      ],
      paging: {
        first: 1000,
      },
    },
    'businessAlertReadsFind'
  );

  return businessAlertReadData?.nodes;
};
